module.exports = __webpack_public_path__ + "partylineManage/img/partylineDark.207f1b19.png";